// import Backbone from 'backbone';
// import _ from 'underscore';
const Backbone = require('backbone');
const _ = require('underscore');

Backbone.Collection.prototype._prepareModel = function (attrs, options) {
  const ModelStore = require('stores/anyguide/model').default;
  let model;

  if (attrs instanceof Backbone.Model) {
    model = attrs;
  } else {
    options = options ? _.clone(options) : {};
    model = ModelStore._requireWithAttributes(
      this.modelName,
      attrs.id,
      attrs,
      options
    );
    if (model.validationError) {
      this.trigger('invalid', this, model.validationError, options);
      return false;
    }
  }
  // Keep an eye out for removals by the ModelStore
  this.listenTo(model, 'MS:remove', this.modelRemoved);

  return model;
};

const Collection = Backbone.Collection.extend({
  url() {
    const filtersQuery = Backbone.$.param(this.filters);
    if (filtersQuery !== '') {
      return `${this.urlBase}?${filtersQuery}`;
    }
    return this.urlBase;
  },

  modelRemoved(model) {
    this.remove(model, { silent: true });
    this.trigger('sync', this);
  },
});

module.exports = Collection;
